export function getVendorRegStage() {
  const stage = localStorage.getItem("vendorRegStage");
  return parseInt(stage ?? 0);
}
